<template>
 <svg
  :width="width"
  :height="height || width"
  :aria-label="title"
  :aria-hidden="!title"
  focusable="false"
  role="img">
    <use :xlink:href="`icons.svg#app-icon-${icon}`" />
</svg>
</template>

<script>
import '@/assets/icons/svg/priest.svg';
import '@/assets/icons/svg/angel.svg';
import '@/assets/icons/svg/monitor.svg';

export default {
  name: 'SvgIcon',
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number
    },
    title: {
      type: String
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style>

</style>
